import { EmployeeCalendar } from "@/components/employee-calendar"
import { AdminDashboard } from "@/components/admin-dashboard"
import { Header } from "@/components/header"
import { useAuth } from "@/lib/auth-context"
import { RoleSelectionDialog } from "@/components/auth/RoleSelectionDialog"
import { Spinner } from "@/components/ui/spinner"

/**
 * Home Component (Role-Based Routing)
 *
 * Routes authenticated users to the appropriate dashboard based on their selected role.
 * For users with multiple roles, displays a selection dialog.
 */
export default function Home() {
  const { user, selectedRole, availableRoles, setSelectedRole, isLoading } = useAuth()

  // Show loading state
  if (isLoading || !user) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <Spinner className="mx-auto mb-4" />
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    )
  }

  // Check if user has no valid roles
  if (availableRoles.length === 0) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center max-w-md p-6">
          <h2 className="text-2xl font-bold mb-4">Access Denied</h2>
          <p className="text-muted-foreground mb-4">
            You don't have the required roles to access this application. Please contact your administrator to
            request access.
          </p>
        </div>
      </div>
    )
  }

  // Show role selection dialog for multi-role users
  const showRoleDialog = availableRoles.length > 1 && !selectedRole

  return (
    <>
      {/* Role Selection Dialog */}
      <RoleSelectionDialog open={showRoleDialog} onRoleSelect={setSelectedRole} />

      {/* Main Content - Only shown after role is selected */}
      {selectedRole && (
        <>
          <Header />
          {selectedRole === "admin" ? <AdminDashboard /> : <EmployeeCalendar />}
        </>
      )}
    </>
  )
}
